const tunnel = {
  badge: "🚀 EXPERTISE IA & FULL-STACK",
  title: "Concrétisez Votre Projet IA : De l'Idée au Déploiement",
  subtitle: "Vous avez un projet d'application, de SaaS ou d'automatisation ? Confiez sa réalisation à un expert qui maîtrise toute la chaîne technique.",
  
  benefits: {
    time: "Cadrage technique complet pour éviter les erreurs de conception coûteuses.",
    money: "Architecture optimisée (MVP) pour lancer vite sans gaspiller votre budget.",
    speed: "Prototype fonctionnel livré en moins de 15 jours pour valider votre marché."
  },

  leadMagnetTitle: "🎯 Réservez Votre Session de Cadrage Technique (Offerte)",
  leadMagnetSubtitle: "30 minutes pour définir l'architecture de votre futur produit IA",
  
  preview: {
    title: "Au programme de cet échange :",
    auto1: "Analyse de faisabilité technique de votre projet.",
    auto2: "Choix de la stack technologique (LLM, Backend, Frontend).",
    auto3: "Définition du périmètre MVP (Minimum Viable Product).",
    auto4: "Estimation réaliste des délais et du budget.",
    auto5: "Recommandations sur l'industrialisation et le déploiement.",
    bonus: "Livrable : Un compte-rendu avec roadmap technique personnalisée."
  },

  form: {
    firstName: "Votre nom",
    email: "Email professionnel",
    button: "📅 Réserver mon Appel de Cadrage",
    security: "🔒 Session limitée à 5 projets par semaine."
  },

  demo: {
    title: "Découvrez la Solution en Action"
  },

  stats: {
    downloadsValue: "15+",
    downloadsLabel: "projets IA déployés avec succès",
    deployedValue: "95%",
    deployedLabel: "satisfaction client sur le cadrage",
    avgTimeValue: "< 15j",
    avgTimeLabel: "Prototype fonctionnel"
  },

  trust: {
    title: "Pourquoi me confier votre projet ?",
    scientific: "Expertise de Haut Niveau : Ex-chercheur InterDigital, brevet en Deep Learning.",
    pragmatic: "Orienté Produit : 4+ ans d'expérience à transformer des idées en SaaS fonctionnels.",
    speed: "Full-Stack Réel : Je gère tout, de la base de données à l'interface utilisateur."
  },

  testimonials: {
    title: "Ce qu'en disent mes clients",
    valerie: {
      name: "Valérie Noiton",
      role: "Head of Supply Chain – Eutelsat Group",
      content: "Alexandre fait preuve d’une véritable conscience professionnelle. Très impliqué dans le projet, il a su tirer le meilleur de l’équipe pour concevoir un outil qui a profondément amélioré le quotidien des collaborateurs. Sa disponibilité, son sens de l’écoute et sa capacité à comprendre les enjeux métiers ont fait toute la différence. Le résultat est un outil fiable, utile et parfaitement adapté aux besoins opérationnels."
    },
    jeanMichel: {
      name: "Jean-Michel",
      role: "Technical Chief – Eutelsat Group",
      content: "L’outil développé par Alexandre est tout simplement exceptionnel. Il s’agit d’un véritable levier stratégique pour l’entreprise. Alexandre se distingue par sa grande réactivité, sa disponibilité constante et sa capacité à piloter un projet avec rigueur tout en restant à l’écoute des besoins techniques et métiers. Son professionnalisme et son sens de l’engagement font de lui un excellent chef de projet, capable de transformer une vision en solution concrète et performante."
    },
    cedric: {
      name: "Cédric Magné",
      role: "Dirigeant – CydJerr",
      content: "Alexandre a été d’un soutien majeur tout au long de la mission. Sa capacité à s’adapter rapidement et à proposer des solutions réalistes et viables lui a permis de mener le projet à bien dans un contexte exigeant. Grâce à son expertise full-stack, il a notamment pu redéployer une application mobile critique après un crash, en un temps record."
    },
    ahmed: {
      name: "Ahmed Ly",
      role: "PMO – Test de Menta Company",
      content: "L’outil développé par Alexandre répond à un véritable besoin, aussi bien pour les managers que pour les collaborateurs. Sa compréhension fine des attentes des utilisateurs, appuyée par une étude de marché rigoureuse et bien menée, a permis de concevoir une solution réellement pertinente. Ce projet illustre parfaitement la capacité d’Alexandre à transformer une analyse métier approfondie en un outil concret, efficace et opérationnel."
    }
  },

  closing: {
    title: "💎 Ne laissez pas votre projet au stade de l'idée",
    subtitle: "La différence entre un succès et un échec réside souvent dans les premières décisions techniques.",
    item1: "Validation de votre architecture IA",
    item2: "Audit de votre stack actuelle",
    item3: "Plan d'action immédiat pour votre MVP",
    button: "🚀 Je lance mon projet maintenant",
    guarantee: "✅ 30 min de pure valeur, sans obligation de collaboration."
  }
};

export default tunnel;
